import { FC, useContext, useMemo } from "react";

import {
  excludeProcessCanceledByUserErrors,
  groupProcessErrorsByReason,
  splitGroupedProcessErrorsBySuccessIds,
} from "@ryde/shared";

import { ProcessDrawerContext } from "../process-drawer-context";
import { ProcessErrorsGeneric } from "./process-errors-generic";

export const ProcessErrorsStrategy: FC = () => {
  const { currentProcess } = useContext(ProcessDrawerContext);
  const { skipped, warnings } = useMemo(() => {
    const grouped = groupProcessErrorsByReason(
      excludeProcessCanceledByUserErrors(currentProcess?.errors),
    );
    // Errors whose ids are also in successIds are warnings, not skips.
    return splitGroupedProcessErrorsBySuccessIds(
      grouped,
      currentProcess?.metadata?.metrics?.successIds,
    );
  }, [currentProcess?.errors, currentProcess?.metadata?.metrics?.successIds]);

  if (!skipped.length && !warnings.length) {
    return null;
  }

  return (
    <>
      <ProcessErrorsGeneric kind="skipped" groupedErrors={skipped} />
      <ProcessErrorsGeneric kind="warnings" groupedErrors={warnings} />
    </>
  );
};
